<template>
  <div
    class="water-on-paper-dry-mass-chart avoid-break"
    :class="{ 'water-on-paper-dry-mass-chart-alarmed': chartData.alarmed }">
    <div class="text-center">
      <strong>
        {{ $t('engineering.water-on-paper.water-on-paper-winding') }} {{ windingId }}
      </strong>
    </div>
    <div v-if="hasDataForWinding">
      <e-chart
        class="water-on-paper-dry-mass-chart__chart"
        autoresize
        ref="waterOnPaperDryMassChart"
        :options="options"
        @rendered="onRendered"
      />
      <img
        class="water-on-paper-dry-mass-chart__image img-fluid avoid-break"
        alt="water-on-paper-dry-mass-chart-image"
        :src="chartImg"
      >
      <div class="water-on-paper-dry-mass-chart__last-register">
        <strong>
          {{ $t('engineering.water-on-paper.last-register') }}:
        </strong>
        <span>
          {{ lastRegister }}
        </span>
      </div>
    </div>
    <s-empty-list v-else />
  </div>
</template>

<script>
import themeService from '@/services/themeService';
import { DryMassChartVariables } from 'sigma-mappings';
import engineeringQuickChartsMixin
  from '@/domain/mixins/installation/engineering/engineeringQuickChartsMixin';

export default {
  name: 'WindingTemperatureChart',
  mixins: [engineeringQuickChartsMixin],
  props: {
    windingId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    options() {
      const series = this.getChartSeries();
      return {
        backgroundColor: this.bgColor,
        tooltip: {
          show: true,
          confine: false,
          trigger: 'item',
          borderColor: themeService.getStyleVar('color-tooltip-border'),
          formatter: this.getTooltipFormatter,
          axisPointer: {
            type: 'cross',
            label: {
              show: false,
            },
            crossStyle: {
              opacity: 0,
            },
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: this.labelSize,
          },
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: this.fontColor,
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: this.fontColor,
            },
          },
          scale: true,
          max: value => (value.max > 100 ? 100 : null),
          min: 0,
          splitNumber: 3,
          minInterval: 1,
          maxInterval: 25,
          axisLabel: {
            show: true,
            showMinLabel: false,
            fontSize: this.labelSize,
            color: this.fontColor,
            formatter: `{value}${this.chartData.unit}`,
          },
          splitLine: {
            show: false,
          },
        },
        grid: {
          top: 20,
          bottom: 40,
          right: 30,
          left: 50,
        },
        series,
      };
    },
    hasDataForWinding() {
      return this.chartData.windingId;
    },
  },
  methods: {
    getLineColorByName(name) {
      return name === DryMassChartVariables.ADMISSIBLE_PAPER_WATER_LIMIT
        ? `${themeService.getStyleVar('color-danger')}8c`
        : themeService.getPrimaryColor();
    },
    onRendered() {
      this.$nextTick(() => {
        this.chartImg = this.isCollapsed || !this.$refs.waterOnPaperDryMassChart.height
          ? '#'
          : this.$refs.waterOnPaperDryMassChart.getDataURL();
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .water-on-paper-dry-mass-chart
    display: block
    border: 1px solid $color-border-gray
    padding: 10px
    border-radius: 3px
    &-alarmed
      border: none
      box-shadow: 0 0 3px var(--color-danger-light),
      \ inset 0 0 3px var(--color-danger-light) !important
    &__last-register
      width: 100%
      text-align: right
      font-size: .8em
    &__chart
      border: 1px solid var(--color-border-dark)
      border-radius: 5px
      min-height: 210px
      height: max-content
      width: 100%
      margin: 10px 0
    &__image
      display: none
    @media print
      .water-on-paper-dry-mass-chart
        text-align: center
        &__chart
          display: none
        &__image
          display: block
</style>
